<template>
  <OverviewCard
    :title="$t('key_dashboard_preparation_time')"
    :subtitle="$t('key_dashboard_preparation_time_hint')"
    :loading="loading"
    :error="error"
    :empty="!data.total"
  >
    <div v-for="(bucket, index) in data.buckets" :key="index" class="bucket-row">
      <span class="text-sm font-weight-bold bucket-label">{{ label(bucket) }}</span>
      <MeterBar class="flex-grow-1 mx-3" :value="bucket.percent" :color="color(index)" height="1.4rem" />
      <span class="text-sm font-weight-bold bucket-percent">{{ percent(bucket.percent) }}</span>
    </div>
  </OverviewCard>
</template>

<script>
import MeterBar from "./MeterBar.vue";
import OverviewCard from "./OverviewCard.vue";
import { COLORS, formatPercent } from "./shared";

// The buckets come with their bounds from the back, so a change of the
// service levels (24h / 48h today) needs no front change.
export default {
  name: "PreparationTime",
  components: { MeterBar, OverviewCard },
  props: {
    data: { type: Object, default: () => ({ total: 0, buckets: [] }) },
    loading: { type: Boolean, default: false },
    error: { type: [Object, Error, String], default: null },
  },
  methods: {
    label({ min_hours: min, max_hours: max }) {
      if (min === null) {
        return `< ${max}h`;
      }
      if (max === null) {
        return `> ${min}h`;
      }
      return `${min} - ${max}h`;
    },
    color(index) {
      if (index === 0) {
        return COLORS.green;
      }
      return index === this.data.buckets.length - 1 ? COLORS.red : COLORS.greenLight;
    },
    percent(value) {
      return formatPercent(value, this.$i18n.locale);
    },
  },
};
</script>

<style scoped>
.bucket-row {
  display: flex;
  align-items: center;
  margin-bottom: 1.1rem;
}

.bucket-label {
  min-width: 4.5rem;
}

.bucket-percent {
  min-width: 3rem;
  text-align: right;
}
</style>
